import React from "react";
import { FaUser } from "react-icons/fa";
import { FaShield } from "react-icons/fa6";

type IMemberTag = {
  value: string;
  className?: string;
};

const MemberTag: React.FC<IMemberTag> = ({ value, className }) => {
  const Icon = value === "Company Admin" ? FaShield : FaUser;
  return (
    <span
      className={`px-2 py-1 leading-[10px] rounded-xl flex items-center gap-1 ${className}`}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {value}
    </span>
  );
};

export default MemberTag;
